import { ReactNode } from 'react';
import { createPortal } from 'react-dom';

import { useDataFileContext } from '../../contexts/DataFileContext/useDataFileContext.js';

export const NavbarSlot = ({ children }: { children: ReactNode }) => {
  const { actionsContainerElement } = useDataFileContext();

  if (!actionsContainerElement) {
    return null;
  }

  return createPortal(children, actionsContainerElement);
};
